// IE対策のpromise-polyfill
import 'promise-polyfill/src/polyfill'

import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
import router from './router'
import App from './App'
import 'jquery/dist/jquery'
// import 'jquery-ui'
import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/theme.css'
import 'bootstrap/dist/js/bootstrap'
import mixinApp from '@/mixins/app'
import mixinApi from '@/mixins/api'
import Utils from '@/plugins/Utils'
import VueVisible from '@/plugins/VueVisible'
import VueImgSrc from '@/plugins/VueImgSrc'
import PortalVue from 'portal-vue'

// API 関連
import Api from '@/plugins/Api'
import _ApiAdapter from '@/plugins/ApiAdapter'

// Vue
Vue.use(Vuex)
Vue.config.productionTip = false

// adminLTE
require('admin-lte/dist/js/adminlte.min.js')

const ApiAdapter = _ApiAdapter.instance({})

// Plugins
Vue.use(Utils)
Vue.use(Api, { ApiAdapter })
Vue.use(VueVisible)
Vue.use(VueImgSrc)
Vue.use(PortalVue)

// Global Mixin
Vue.mixin({
  mixins: [ mixinApp, mixinApi ]
})

/*
 * vue
 * アプリ全体のコントローラ
 */
new Vue({ // eslint-disable-line no-new
  el: '#bcard',
  router: router,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js